// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2682":"31d6cfe0","5429":"c77a9728","6686":"3626e542","9749":"31d6cfe0"}[chunkId] + ".chunk.css";
};